export const getImageSize = (imageSize) => ({
  width: imageSize.width || 400,
  height: imageSize.height || 400,
})

// Cap requested pixel ratio at 2x: the visual difference between 2x and 3x
// is imperceptible for product photography, but the byte savings are
// substantial (a typical PDP carousel image drops from ~326KB to ~151KB at
// 2x vs 3x), which matters most on mobile where devicePixelRatio is often 3.
const MAX_PIXEL_RATIO = 2

export const getCompressedImageUrl = (src, width, height) => {
  // Server-rendered callers reach this too: the video poster is compressed
  // during render, not behind a client-only effect the way carousel images
  // are. Fall back to 1x off the browser so SSR cannot throw on `window`.
  const devicePixelRatio =
    typeof window === 'undefined' ? 1.0 : window.devicePixelRatio
  const pixelRatio = Math.min(devicePixelRatio || 1.0, MAX_PIXEL_RATIO)
  const imageWidth = Math.round(width * pixelRatio)
  const imageHeight = Math.round(height * pixelRatio)
  return `${src}?auto=compress,format&fm=webp,jpg,png&w=${imageWidth}&h=${imageHeight}`
}

export default { getImageSize, getCompressedImageUrl }
